import Common from '../../../shared/Common';
import { tableDataBlackColor, tableDataRedColor, tableDataGreenColor } from './colors';
import { IGenericFinancialValue } from './types';

interface FinancialChartProps {
  data: IGenericFinancialValue[];
  isWeekly: boolean;
  includeTaxes: boolean | undefined;
  includeFuture: boolean | undefined;
  groupByYears: boolean | undefined;
}

const FinancialTable = ({ data, isWeekly, includeTaxes, includeFuture }: FinancialChartProps) => {
  let chartData = data;
  if (!includeFuture) {
    if (isWeekly) {
      chartData = chartData.filter((e) => new Date() >= Common.Utils.getDateOfIsoWeek(e.week, e.year));
    } else {
      chartData = chartData.filter((e) => new Date() >= new Date(e.year, e.month - 1));
    }
  }
  const items = [];
  for (let itemInd = chartData.length - 1; itemInd >= 0; itemInd--) {
    const curentRow = chartData[itemInd];
    let totalExpense = curentRow.totalExpense;
    let totalIncome = curentRow.totalIncome;
    if (!includeTaxes) {
      totalExpense -= curentRow.totalTax;
      totalIncome -= curentRow.totalTax;
    }
    const previousRow = itemInd - 1 >= 0 ? chartData[itemInd - 1] : chartData[itemInd];
    const absoluteDiffrence = totalIncome - totalExpense;
    const previousRowAbsoluteDiffrence = previousRow.totalIncome - previousRow.totalExpense;
    let relativeDiffrence;
    if (previousRowAbsoluteDiffrence < 0 && absoluteDiffrence > 0) {
      relativeDiffrence = 100; // Traktujemy przejście z ujemnej do dodatniej wartości jako 100% wzrost
    } else {
      relativeDiffrence =
        ((absoluteDiffrence - previousRowAbsoluteDiffrence) / Math.abs(previousRowAbsoluteDiffrence)) * 100;
    }

    const relativeDifferenceColor =
      isNaN(relativeDiffrence) || !isFinite(relativeDiffrence)
        ? tableDataBlackColor
        : relativeDiffrence < 0
          ? tableDataRedColor
          : tableDataGreenColor;

    items.push(
      <tr key={chartData + '-' + itemInd}>
        <td>{isWeekly ? chartData[itemInd].week : chartData[itemInd].month}</td>
        <td>{Common.Utils.getCurrencyString(totalExpense)}</td>
        <td>{Common.Utils.getCurrencyString(totalIncome)}</td>
        <td>{Common.Utils.getCurrencyString(absoluteDiffrence)}</td>
        <td
          style={{
            color: relativeDifferenceColor,
            fontWeight: 'bold',
          }}
        >
          {isNaN(relativeDiffrence) || !isFinite(relativeDiffrence) ? '---' : relativeDiffrence.toFixed(2) + '%'}
        </td>
      </tr>
    );
  }

  return (
    <div className='table-responsive' style={{ maxHeight: '400px', overflow: 'auto' }}>
      <table className='table table-without-border-bottom'>
        <thead>
          <tr>
            <th scope='col'>{isWeekly ? 'Tydzień' : 'Miesiąc'}</th>
            <th scope='col'>Suma wydatków</th>
            <th scope='col'>Suma przychodów</th>
            <th scope='col'>Bilans</th>
            <th scope='col'>Różnica względna</th>
          </tr>
        </thead>
        <tbody>{items}</tbody>
      </table>
    </div>
  );
};

export default FinancialTable;
